// extracted by mini-css-extract-plugin
export default {"choiceCard":"ChoiceCard_choiceCard__-Lcmn","catDogIcon":"ChoiceCard_catDogIcon__Zw6M6","catDogIconText":"ChoiceCard_catDogIconText__koe7T","checked":"ChoiceCard_checked__YIfza"};